import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getCurrentUser, isAuthenticated, logout as apiLogout, getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (isAuthenticated()) {
        try {
          const userData = await getMe();
          setUser(userData);
        } catch (error) {
          // Token expired or invalid
          apiLogout();
          setUser(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    apiLogout();
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('roomhub_user', JSON.stringify(userData));
  };

  // Refresh user data from the server
  const refreshUser = useCallback(async () => {
    if (isAuthenticated()) {
      try {
        const userData = await getMe();
        setUser(userData);
        localStorage.setItem('roomhub_user', JSON.stringify(userData));
        return userData;
      } catch (error) {
        console.error('Failed to refresh user:', error);
        throw error;
      }
    }
    return null;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser, refreshUser, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
